'use client';

import { useEffect } from 'react';

import { Columns, PricingTable, Slider, SliderItem, View } from '@bytel/trilogy-react-ts';

import { OptionType, PlanType } from '@app-types/product';

import { scrollToElement } from '@helpers/utils';

import { ProductCatalogItem } from './product-catalog-item';

interface ProductsCatalogProps {
    catalogue: Array<PlanType>;
    blockedOption?: OptionType;
}

export function ProductsCatalog({ catalogue, blockedOption }: Readonly<ProductsCatalogProps>) {
    useEffect(() => {
        scrollToElement('#cataloguesBytel');
    }, []);

    return (
        <View flexable className='is-centered'>
            <View className='mWAppX2'>
                <PricingTable className='mWAppX extra-mobile-offers'>
                    <Columns multiline className='is-hidden-mobile'>
                        {catalogue.map((product) => {
                            return (
                                <ProductCatalogItem
                                    product={product}
                                    key={product.gencode}
                                    isHalfWidth
                                    blockedOption={blockedOption}
                                />
                            );
                        })}
                    </Columns>
                    <Slider className='slider is-hidden-tablet is-hidden-desktop'>
                        {catalogue.map((product) => {
                            return (
                                <SliderItem size={10} key={product.gencode}>
                                    <ProductCatalogItem
                                        product={product}
                                        isHalfWidth={false}
                                        blockedOption={blockedOption}
                                    />
                                </SliderItem>
                            );
                        })}
                    </Slider>
                </PricingTable>
            </View>
        </View>
    );
}
